'use strict'

const isPlainObject_ = require('lodash/isPlainObject')

const RESOLVER_KEY = '@resolver'
const RESOLVER_VALUE = 'dataBinding'

module.exports.addDataBindingResolver = filterExpression =>
  Object.assign({}, filterExpression, { [RESOLVER_KEY]: RESOLVER_VALUE })

module.exports.shouldDataBindingResolve = filterExpression =>
  isPlainObject_(filterExpression) &&
  filterExpression[RESOLVER_KEY] === RESOLVER_VALUE



// WEBPACK FOOTER //
// ../node_modules/dbsm-common/src/dataBindingFilterResolver.js